import { createFileRoute } from '@tanstack/react-router'

import VCard from 'pages/VCard'

export const Route = createFileRoute('/_auth/vcard')({
  component: VCard,
})
